import { render, staticRenderFns } from "./AuctionBanner.vue?vue&type=template&id=b32778bc"
import script from "./AuctionBanner.vue?vue&type=script&lang=js"
export * from "./AuctionBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports